module.exports = __webpack_public_path__ + "img/ico-notify-danger.8f81f374.svg";